import React from 'react';
import Wrapper from '../containers/home/wrapper';

const Home = () => (
  <Wrapper />
);

export default Home;
